<div *ngIf="!isLoading; else spinner" >
  <h1 mat-dialog-title xmlns="http://www.w3.org/1999/html">
    <ng-container *ngIf="alert.title; else addTitle">Edit Airport Alert</ng-container>
  </h1>
  <mat-dialog-content [formGroup]="formGroup">
    <div class="form-container">
      <p>
      <mat-form-field>
        <mat-select placeholder="Priority *" [(value)]="selectedPriority" name="priority" formControlName="priority">
          <mat-option value="Low">Low</mat-option>
          <mat-option value="High">High</mat-option>
        </mat-select>
      </mat-form-field>
      </p>
      <p>
      <mat-form-field id="titleField">
        <input matInput
               placeholder="Title *"
               formControlName="title"
               [(ngModel)]="selectedTitle"
               maxlength="200">
      </mat-form-field>
      </p>
      <p>
      <mat-form-field id="descriptionField">
        <textarea matInput
               placeholder="Description *"
               formControlName="description"
               [(ngModel)]="selectedDescription"
               rows="8">
        </textarea>
        <mat-hint align="end" *ngIf="selectedDescription">{{selectedDescription.length}} / 2000</mat-hint>
      </mat-form-field>
      </p>
      <p>
      <mat-form-field id="websiteField">
        <input matInput
               placeholder="Website URL"
               formControlName="website"
               [(ngModel)]="selectedWebsite"
               maxlength="200">
      </mat-form-field>
      </p>
      <p>
      <mat-form-field>
        <input matInput disabled="{{selectedPermanent}}" [matDatepicker]="picker1" placeholder="Effective Date *" formControlName="effectiveDate" [(ngModel)]="selectedEffectiveDate">
        <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
        <mat-datepicker #picker1 [disabled]="selectedPermanent"></mat-datepicker>
      </mat-form-field>
      <mat-form-field *ngIf="isNew || !selectedPermanent">
        <input matInput disabled="{{selectedPermanent}}" [matDatepicker]="picker2" placeholder="Expiration Date *" formControlName="expirationDate" [(ngModel)]="selectedExpirationDate">
        <mat-datepicker-toggle matSuffix [for]="picker2" ></mat-datepicker-toggle>
        <mat-datepicker #picker2 [disabled]="selectedPermanent"></mat-datepicker>
      </mat-form-field>
      </p>
      <p> <mat-checkbox formControlName="hide" [(ngModel)]="selectedHidden" [disabled]="selectedPermanent">Hide Dates</mat-checkbox></p>
      <p> <mat-checkbox input  matInput formControlName="permanent" [(ngModel)]="selectedPermanent" [disabled]="selectedHidden" (click)="clickPermanent()">Permanent</mat-checkbox></p>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button type="submit" [disabled]="!formGroup.valid" class="mat-raised-button submit-button" (click)="save()">
      Save
    </button>
    <button id="cancelButton" class="mat-raised-button" (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>
<ng-template id="spinnerContainer" #spinner>
  <mat-dialog-content>
    <mat-spinner id="spinner" [diameter]="100" [color]="'accent'"></mat-spinner>
  </mat-dialog-content>
</ng-template>
<ng-template #addTitle>
  Add Airport Alert
</ng-template>
